export const ProductDetailsException = [
    'B2C',
    'shipping',
    'Shopify 4 kategória',
    'Márka',
];
